export default __webpack_public_path__ + "static/media/sports-illustration.b8be8135.svg";